import isEmpty from '../../is-Empty';
import validator from 'validator';

export const RestaurantTypeValidation = (data) => {
  let errors = {};
  data.cost_for_two = !isEmpty(data.cost_for_two) ? data.cost_for_two : '';
  data.revenue = !isEmpty(data.revenue) ? data.revenue : '';

  if (validator.isEmpty(data.cost_for_two)) {
    errors.cost_for_two = 'Cost is required';
  }
  if (validator.isEmpty(data.revenue)) {
    errors.revenue = 'Revenue is required';
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
